import { Component } from '@angular/core';
import { PopupService } from '../../services/popup.service';

@Component({
    selector: 'ez-popup',
    template: require('./popup.component.html'),
    styles: [require('./popup.component.less')]
})
export class PopupComponent {

    constructor(protected popupService: PopupService) {}

    protected close(): void {
        this.popupService.close();
        this.popupService.destroyPopup();
    }

    protected sendResult(data): void {
        this.popupService.accept(data);
    }

    protected getData(index?: string): any {
        return this.popupService.getData(index);
    }

    protected hasData(index?: string): boolean {
        return this.popupService.hasData(index);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/popup/popup.component.ts